import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { compose, withHandlers, withState, withStateHandlers, withProps, withPropsOnChange } from 'recompose';
import NewNote from "./NewNote";
import { newNoteEnhancer, newNoteLoadingEnhancer, newPrivateNoteEnhancer, newPrivateNoteLoadingEnhancer } from "../../../enhancers/studentApplication";
var emptyNote = {
  title: null,
  body: '',
  visibility: 'public',
  dirty: false,
  template: null
};
var commonEnhancer = compose(withStateHandlers(function (_ref) {
  var note = _ref.note;
  return {
    stateNote: _objectSpread(_objectSpread(_objectSpread({}, emptyNote), note), {}, {
      dirty: false
    })
  };
}, {
  setNote: function setNote(_ref2) {
    var stateNote = _ref2.stateNote;
    return function (updatedNote) {
      return {
        stateNote: _objectSpread(_objectSpread({}, stateNote), updatedNote)
      };
    };
  }
}), withPropsOnChange(['userPermissions'], function (_ref3) {
  var userPermissions = _ref3.userPermissions;
  return {
    advancedEditor: userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.create_private_note,
    createPrivateNoteFromTemplate: userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.create_private_note_from_template,
    createPublicNoteFromTemplate: (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.create_public_note_from_admin_template) || (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.create_public_note_from_agent_template),
    showNoteTemplates: userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.index_note_template,
    viewRestrictedNote: userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.view_restricted_note
  };
}), withPropsOnChange(['note'], function (_ref4) {
  var agentId = _ref4.agentId,
    note = _ref4.note,
    setNote = _ref4.setNote;
  var changedNote = _objectSpread({}, note);
  if (!agentId) changedNote.email_user = true;
  setNote(changedNote);
  return {};
}), withProps(function (_ref5) {
  var stateNote = _ref5.stateNote;
  return {
    note: stateNote
  };
}), withState('quill', 'setQuill'), withHandlers({
  onChangeHandler: function onChangeHandler(_ref6) {
    var note = _ref6.note,
      onChange = _ref6.onChange;
    return function (updatedNote) {
      return onChange(updatedNote !== null && updatedNote !== void 0 ? updatedNote : note);
    };
  }
}));
var newNoteComponentEnhancer = compose(newNoteLoadingEnhancer, newNoteEnhancer, commonEnhancer);
var newPrivateNoteComponentEnhancer = compose(newPrivateNoteLoadingEnhancer, newPrivateNoteEnhancer, commonEnhancer);
export var NewPrivateNote = newPrivateNoteComponentEnhancer(NewNote);
export default newNoteComponentEnhancer(NewNote);